export default __webpack_public_path__ + "static/media/loading.50f507ec.gif";